export default __webpack_public_path__ + "static/media/telefonsecure_mobile.f3879c6f.png";